export const euPlatescPageHandler = (reportUri, body) =>
  fetch(reportUri, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/html',
      'X-Tenant-Key': window._env_.API_TENANT_KEY,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.text())
    .then((html) => {
      document.open();
      document.write(html);
      document.close();
    });
